import Button from "@mui/material/Button";
import React from "react";
import SearchFlow from "../searchFlow/searchFlow";
import SearchFlowVersionB from "../searchFlowVersionB/searchFlow";
import { getOrPickVariant } from "../utils/abVariant";
import { canAccessFlowVersionB } from "../utils/flowVersionBAccess";

// Query params only the plain (variant A) flow understands how to bootstrap from
// (e.g. external links landing straight on its CompanyType step). Present means:
// force variant A for this request only — don't touch the visitor's sticky A/B
// cookie, so a later back-navigation to the bare route still resolves the variant
// normally.
const LEGACY_BOOTSTRAP_PARAMS = ["existing", "companytype"];

const hasLegacyBootstrapParams = () =>
  LEGACY_BOOTSTRAP_PARAMS.some((param) =>
    new URLSearchParams(window.location.search).has(param),
  );

const SearchFlowABEntry = () => {
  // Real 5%-of-visitors A/B roll (sticky cookie) — searchFlowVersionB is the only
  // "B" flow live for real traffic right now.
  const variant = React.useMemo(() => {
    if (hasLegacyBootstrapParams()) return "A";
    return getOrPickVariant("searchflow");
  }, []);

  const [useVersionB, setUseVersionB] = React.useState(false);
  const canSwitchToVersionB = canAccessFlowVersionB();
  const shouldShowVersionB = variant === "B" || useVersionB;

  return (
    <>
      {canSwitchToVersionB && !shouldShowVersionB && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => setUseVersionB(true)}
          sx={{ mb: 2 }}
        >
          Open SearchFlow B
        </Button>
      )}
      {shouldShowVersionB ? <SearchFlowVersionB /> : <SearchFlow />}
    </>
  );
};

export default SearchFlowABEntry;
